import React from "react";
import DND from "../pages/canvas/paper/dndhandler";
import Render from "../pages/canvas/paper/render";

export default function Row(props) {
  return (
    <div
      ref={props.editorRef}
      style={{
        display: "flex",
        flexWrap: "wrap",
        position: "relative",
        boxSizing: "border-box",
        width: "100%",
        overflowY: "scroll",
        visibility: props.block.hidden ? "hidden" : "unset",
        flexGrow: props.block.props.flexGrow,
        backgroundColor: props.block.props.backgroundColor,
        justifyContent: props.block.props.justifyContent,
        alignItems: props.block.props.alignItems,
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
    >
      {props.children.map((block, index) => {
        const newPath = [...props.path];
        newPath.push(index);

        return (
          <DND
            key={block.id}
            disabled={props.disabled}
            block={block}
            path={newPath}
            index={index}
          >
            <Render />
          </DND>
        );
      })}
    </div>
  );
}
